<template>
    <v-footer app fixed>
        <span id="footer">
          <a href="https://emcsoft.com.br" target="_blank"><v-img src="/img/emcsoft_logo.png" max-width="80" /></a>
        </span>
        <v-spacer/>
        <span id="footer">
            <v-chip v-if="isStaging && user.is_internal" class="ma-2" color="indigo" outlined small>
                <v-icon small left color="green">mdi-vuejs</v-icon>v{{ vueVersion }}
            </v-chip>
            <v-chip v-if="isStaging && user.is_internal" class="ma-2" color="indigo" outlined small>
                <v-icon small left color="blue">mdi-vuetify</v-icon>v{{ vuetifyVersion }}
            </v-chip>
            <span color="white" v-if="acesso.grupo != null" class="text-caption"><strong>{{ footer }}</strong></span>
        </span>
    </v-footer>
</template>

<script>

import { mapState } from 'vuex'
import Vue from 'vue'
import Vuetify from 'vuetify'


export default {
    name: 'SysCoreFooter',
    data: () => ({
        year: new Date().getFullYear(),
        env_sysclass: process.env.VUE_APP_ENV,
        vueVersion: Vue.version,
        vuetifyVersion: Vuetify.version
    }),
    computed: {
        ...mapState('auth', ['acesso', 'user']),
        isStaging(){
            return !this.env_sysclass || !this.env_sysclass.toString().includes('production');
        },
        footer() {
            
            if(!! Object.keys(this.acesso).length){
                return this.acesso.instituicao.name + " | " + this.acesso.periodo.name;
            }

            return "";
        }

    },
    
    
}
</script>